import { call, put, takeEvery } from "redux-saga/effects";
import { setPayment, setProcessLoading } from "../../../../store/action";
import { transactionService } from "../../services/dependency.injection";
import { TransactionActionTypes } from "../actions/actionTypes";

function* callGetPayment({ payload: value }) {
    yield put(setProcessLoading(true));

    const response = yield call(transactionService.getAllPayment, value);

    if (response.isRight()) {
        yield put(setPayment(response.value.getValue()));
        yield put(setProcessLoading(false));
    } else {
        yield put(setProcessLoading(false));
    }
}

export function* watchCallGetPayment() {
    yield takeEvery<any>(TransactionActionTypes.GET_PAYMENT, callGetPayment);
}